import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Stack } from '@mantine/core';
import { PageHeader } from '../../../components/PageHeader';
import { OpenBatchModal } from '../../../features/production-packconv/components/OpenBatchModal';
import { RunsTable } from '../../../features/production-packconv/components/RunsTable';

/** Kiln batches (BUILD_SPEC.md §8.3 BATCH mode) — "Open kiln batch" + a register of
 * BATCH-mode runs, filtered from the shared `RunsTable`. Multiple batches may be
 * OPEN concurrently (spec §5.5); "Close batch" happens on the run's own detail
 * page once outputs are known, days later. */
export const Route = createFileRoute('/_authenticated/production-packconv/batches')({
  component: BatchesPage,
});

function BatchesPage() {
  const navigate = useNavigate();
  return (
    <Stack gap="lg">
      <PageHeader
        title="Kiln batches"
        description="Track kiln batches from cages-in to cages-out."
        actions={<OpenBatchModal onOpened={(runId) => navigate({ to: '/production-packconv/runs/$runId', params: { runId } })} />}
      />
      <RunsTable runMode="BATCH" title="Batches" />
    </Stack>
  );
}
